//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ICuralateStore } from '@models/AppState';

export const getCurrentStartDate = (state: ICuralateStore) => state.twitter.schedule.startDate;
